// @mui
import { ListItemText, ListItemAvatar, ListItem } from "@mui/material";
import Iconify from "../iconify";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import React, { useEffect, useState } from "react";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import axios from "axios";
import moment from "moment";
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  TextField,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Alert,
  OutlinedInput,
  Chip,
} from "@mui/material";
// ----------------------------------------------------------------------
const dateFormat = "YYYY-MM-DD HH:mm:ss";

export default function EditTextSettings(props) {
  return (
    <Card sx={{ padding: 4 }}>
      {props.loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center" }}
          style={{ padding: 20 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Grid container>
          <Grid item xs={12} sx={{ mb: 2 }}>
            <TextField
              id={`title_${props.lang}`}
              label="Pickem Title"
              fullWidth
              value={props.state[`title_${props.lang}`]}
              variant="standard"
              onChange={props.handleChange}
            />
          </Grid>
          <Grid item xs={12} sx={{ mb: 2 }}>
            <TextField
              id={`description_${props.lang}`}
              label="Description"
              fullWidth
              value={props.state[`description_${props.lang}`]}
              variant="standard"
              onChange={props.handleChange}
            />
          </Grid>
          <Grid item xs={12} sx={{ mb: 2 }}>
            <TextField
              id={`prize_text_${props.lang}`}
              label="Prize Text"
              fullWidth
              value={props.state[`prize_text_${props.lang}`]}
              variant="standard"
              onChange={props.handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Prizes Description
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Grid container>
              <Grid item xs={10}>
                <TextField
                  id={`prize_text_${props.lang}`}
                  label="Main Prize Title "
                  fullWidth
                  value={
                    props.state[`prizes_desc_${props.lang}`]
                      ? props.state[`prizes_desc_${props.lang}`][`main_title`]
                      : ""
                  }
                  variant="standard"
                  onChange={(e) =>
                    props.handleChangePrizeDescription(
                      `prizes_desc_${props.lang}`,
                      `main_title`,
                      e.target.value
                    )
                  }
                />
              </Grid>
              <Grid item xs={10}>
                <TextField
                  id={`prize_text_${props.lang}`}
                  label="Main Prize Desc"
                  fullWidth
                  value={
                    props.state[`prizes_desc_${props.lang}`]
                      ? props.state[`prizes_desc_${props.lang}`][`main_desc`]
                      : ""
                  }
                  variant="standard"
                  onChange={(e) =>
                    props.handleChangePrizeDescription(
                      `prizes_desc_${props.lang}`,
                      `main_desc`,
                      e.target.value
                    )
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container>
              <Grid item xs={10}>
                <TextField
                  label="Secondary Prize Title "
                  fullWidth
                  value={
                    props.state[`prizes_desc_${props.lang}`]
                      ? props.state[`prizes_desc_${props.lang}`][
                          `secondary_title`
                        ]
                      : ""
                  }
                  variant="standard"
                  onChange={(e) =>
                    props.handleChangePrizeDescription(
                      `prizes_desc_${props.lang}`,
                      `secondary_title`,
                      e.target.value
                    )
                  }
                />
              </Grid>
              <Grid item xs={10}>
                <TextField
                  id={`prize_text_${props.lang}`}
                  label="Secondary Prize Desc"
                  fullWidth
                  value={
                    props.state[`prizes_desc_${props.lang}`]
                      ? props.state[`prizes_desc_${props.lang}`][
                          `secondary_desc`
                        ]
                      : ""
                  }
                  variant="standard"
                  onChange={(e) =>
                    props.handleChangePrizeDescription(
                      `prizes_desc_${props.lang}`,
                      `secondary_desc`,
                      e.target.value
                    )
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Box>Main Image</Box>
            {props.state[`main_image_${props.lang}`] &&
            props.state[`main_image_${props.lang}`] !== "null" ? (
              <>
                <img
                  style={{
                    margin: "0 auto",
                    width: 100,
                    background: "grey",
                  }}
                  alt="Remy Sharp"
                  src={props.state[`main_image_${props.lang}`]}
                />
                <Iconify
                  icon="eva:edit-outline"
                  sx={{
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    props.setAssetsTarget(`main_image_${props.lang}`)
                  }
                />
                <Iconify
                  icon="eva:close-outline"
                  sx={{
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                  }}
                  onClick={() => props.deleteImage(`main_image_${props.lang}`)}
                />
              </>
            ) : (
              <Iconify
                icon="eva:plus-circle-outline"
                sx={{
                  width: 20,
                  height: 20,
                  cursor: "pointer",
                  marginTop: 2,
                  marginBottom: 2,
                }}
                onClick={() =>
                  props.setAssetsTarget(`main_image_${props.lang}`)
                }
              />
            )}
          </Grid>
          <Grid item xs={6}>
            <Box>Prize Image</Box>
            {props.state[`prize_image_${props.lang}`] &&
            props.state[`prize_image_${props.lang}`] !== "null" ? (
              <>
                <img
                  style={{
                    margin: "0 auto",
                    width: 100,
                    background: "grey",
                  }}
                  alt="Remy Sharp"
                  src={props.state[`prize_image_${props.lang}`]}
                />
                <Iconify
                  icon="eva:edit-outline"
                  sx={{
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    props.setAssetsTarget(`prize_image_${props.lang}`)
                  }
                />
                <Iconify
                  icon="eva:close-outline"
                  sx={{
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                  }}
                  onClick={() => props.deleteImage(`prize_image_${props.lang}`)}
                />
              </>
            ) : (
              <Iconify
                icon="eva:plus-circle-outline"
                sx={{
                  width: 20,
                  height: 20,
                  cursor: "pointer",
                  marginTop: 2,
                  marginBottom: 2,
                }}
                onClick={() =>
                  props.setAssetsTarget(`prize_image_${props.lang}`)
                }
              />
            )}
          </Grid>
          <Grid item xs={6}>
            <Box>Gamezone Image</Box>
            {props.state[`gamezone_image_${props.lang}`] &&
            props.state[`gamezone_image_${props.lang}`] ? (
              <>
                <img
                  style={{
                    margin: "0 auto",
                    width: 100,
                    background: "grey",
                  }}
                  alt="Remy Sharp"
                  src={props.state[`gamezone_image_${props.lang}`]}
                />
                <Iconify
                  icon="eva:edit-outline"
                  sx={{
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    props.setAssetsTarget(`gamezone_image_${props.lang}`)
                  }
                />
                <Iconify
                  icon="eva:close-outline"
                  sx={{
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    props.deleteImage(`gamezone_image_${props.lang}`)
                  }
                />
              </>
            ) : (
              <Iconify
                icon="eva:plus-circle-outline"
                sx={{
                  width: 20,
                  height: 20,
                  cursor: "pointer",
                  marginTop: 2,
                  marginBottom: 2,
                }}
                onClick={() =>
                  props.setAssetsTarget(`gamezone_image_${props.lang}`)
                }
              />
            )}
          </Grid>
          <Grid item xs={6}>
            <Box>Tile Image</Box>
            {props.state[`tile_image_${props.lang}`] &&
            props.state[`tile_image_${props.lang}`] ? (
              <>
                <img
                  style={{
                    margin: "0 auto",
                    width: 100,
                    background: "grey",
                  }}
                  alt="Remy Sharp"
                  src={props.state[`tile_image_${props.lang}`]}
                />
                <Iconify
                  icon="eva:edit-outline"
                  sx={{
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    props.setAssetsTarget(`tile_image_${props.lang}`)
                  }
                />
                <Iconify
                  icon="eva:close-outline"
                  sx={{
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    props.deleteImage(`tile_image_${props.lang}`)
                  }
                />
              </>
            ) : (
              <Iconify
                icon="eva:plus-circle-outline"
                sx={{
                  width: 20,
                  height: 20,
                  cursor: "pointer",
                  marginTop: 2,
                  marginBottom: 2,
                }}
                onClick={() =>
                  props.setAssetsTarget(`tile_image_${props.lang}`)
                }
              />
            )}
          </Grid>
        </Grid>
      )}
    </Card>
  );
}
